<template>
  <!-- <keep-alive>
        <router-view/>
    </keep-alive> -->
  <keep-alive v-if="!blackRoutePath.some((nav, index) => nav === $route.path)">
    <router-view></router-view>
  </keep-alive>
  <router-view v-else></router-view>
</template>
<script>
import { BLACK_ROUTE_PATH } from "@/page/commons/BoskTabNavigation/constant";
export default {
  name: "sale-layout",
  data() {
    return {
      blackRoutePath: [],
    };
  },
  created() {
    this.blackRoutePath = [...BLACK_ROUTE_PATH];
  },
 
};
</script>
